module.exports = __webpack_public_path__ + "assets/img/driver-btn-29e74902.png";